import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { UpdateAppConfigPayload } from "./NetTypes";

async function updateConfigAppRequest({
	orgId,
	appId,
	entityStatus,
	selectionMode,
	entities
}: UpdateAppConfigPayload) {
	return await apiClient
		.put(API.COMMAND.ORGANIZATIONS.APPS.CONFIGURATION(orgId, appId), {
			entityStatus,
			selectionMode,
			entities: selectionMode === "CUSTOM" ? entities : null
		})
		.then((res) => res.data);
}

export function useUpdateConfigApp() {
	return useMutation<any, AxiosError, UpdateAppConfigPayload>({
		mutationFn: (payload: UpdateAppConfigPayload) => updateConfigAppRequest(payload)
	});
}
